/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47797Item {
  
  /** 日志ID */
  id?: string;
  
  /** 人员头像 */
  memberAvatar?: string;
  
  /** 人员名称 */
  memberName?: string;
  
  /** 日志添加时间 */
  time?: string;
  
  /** 日志内容 */
  content?: string;
  
};
    
  



export interface API47797Req {
  
  /** 项目编号 */
  projectNo?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API47797Res {
  /** T  */
  list?: API47797Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 47797 项目日志

export interface IUseGetAPI47797Return {
  /** 项目日志: 接口请求状态 */
  isAPI47797Loading: boolean;
  /** 项目日志: 接口请求返回数据 */
  dataAPI47797: API47797Res;
  /**  项目日志: 接口数据请求方法 */
  fetchAPI47797Data:  (inputs: API47797Req, config?: YWRequestConfig) => Promise<API47797Res>;
  /** 项目日志: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47797 = ():IUseGetAPI47797Return => {
  let isMount = true;
  const [isAPI47797Loading, setIsAPI47797Loading] = useState(false);
  const [dataAPI47797, setDataAPI47797] = useState<API47797Res>({} as API47797Res);
  const requestUrl = `${basePath}/corp-admin/project/log`;

  const fetchAPI47797Data = async (inputs: API47797Req, config?: YWRequestConfig): Promise<API47797Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47797Req>) || {}) as API47797Req;
    
  
    if ( isMount ) {
      setIsAPI47797Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47797Res>(`${basePath}/corp-admin/project/log?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47797(res || {} as API47797Res);
        setIsAPI47797Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47797Loading(false);
      }
      return false as unknown as API47797Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47797Loading,
    dataAPI47797,
    fetchAPI47797Data,
    requestUrl,
  }
}

